<script>
export default {
  props: {
    url: null,
  },

  data() {
    return {
      items: [],
      cancelToken: null,
      isRequestActive: false,
      current: null,
    };
  },

  computed: {
    /**
     * @return {boolean}
     */
    hasItems() {
      return _.size(this.items) > 0;
    }
  },

  watch: {
    items(value) {
      this.current = _.find(value, (item) => this.isItemsEqual(item, this.current)) || null;
    },

    url: {
      handler() {
        this.refresh();
      },
      immediate: true,
    },

    current(value) {
      this.$emit('change', value);
    },

    isRequestActive(value) {
      if (value) {
        this.$emit('refresh-start');
      } else {
        this.$emit('refresh-finish');
      }
    },
  },

  methods: {
    /**
     * @return {undefined}
     */
    performLoading() {
      if (this.isRequestActive) {
        this.cancelToken.cancel();
      } else {
        this.isRequestActive = true;
      }

      this.cancelToken = axios.CancelToken.source();

      axios.get(this.url, {
        cancelToken: this.cancelToken.token
      })
          .then(this.onLoadSuccess)
          .catch(this.onLoadError)
          .then((isCancelled) => {
            if (!isCancelled) {
              this.isRequestActive = false;
            }
          });
    },

    /**
     * @param {Object} data
     * @return {Boolean}
     */
    onLoadSuccess({data: {data: items}}) {
      this.items.push(...items);

      return false;
    },

    /**
     * @param {Object} error
     * @return {Boolean}
     */
    onLoadError(error) {
      return axios.isCancel(error);
    },

    /**
     * @return {undefined}
     */
    refresh() {
      this.items = [];
      this.performLoading();
    },

    /**
     * @param {Object} item
     * @return {Boolean}
     */
    isCurrent(item) {
      return this.isItemsEqual(item, this.current);
    },

    /**
     * @param {object} item1
     * @param {object} item2
     * @return {boolean}
     */
    isItemsEqual(item1, item2) {
      return _.get(item1, 'id') === _.get(item2, 'id');
    },

    /**
     * @param {Object} item
     */
    select(item) {
      this.current = item;
    }
  },
}
</script>
